import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.funding_requirements.all_requirements_completed_title',
        defaultMessage: 'You’ve completed all the steps!'
    },
    caption: {
        id: '_.funding_requirements.all_requirements_completed_caption',
        defaultMessage:
            'Click ‘{next}’ to go to confirm your drawdown. {br} We won’t send the funds to you until you hit ‘Confirm’ on the next step.'
    },
    interestOnlyCaption: {
        id: '_.funding_requirements.all_requirements_completed_interestOnlyCaption_caption',
        defaultMessage:
            'Click ‘{next}’ to extend your loan. {br} The loan will not be extended until you click ‘Confirm‘ in the next step.'
    },
    accessUserTitle: {
        id: '_.funding_requirements.all_requirements_completed_access_user_title',
        defaultMessage: 'You’re all set!'
    },
    accessUserCaption: {
        id: '_.funding_requirements.all_requirements_completed_access_user_caption',
        defaultMessage:
            'The remaining steps will be completed by the applicant.'
    },
    action: {
        id: '_.funding_requirements.all_requirements_completed_action',
        defaultMessage: 'Next'
    }
});
